module.exports = __webpack_public_path__ + "static/media/yay click.6622a99e.gif";